import React, { useEffect, useState } from "react";

import styled from "@emotion/styled";
import { useSelector, useDispatch } from "react-redux";
import useAuth from "../../utils/useAuth";

import "../../components/ReportMonk/custom.css";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

import { Form } from "antd";
import {
  onGetCollectiveReport,
  onGetIndividualReport,
  onGetSchoolInfo,
  onGetMatchList,
} from "../../stores/report";

import ReportForm from "./ReportForm";
import ResultTable from "../../components/ReportMonk/Table/ResultTable";
import CustomChart, { DownloadButton } from "./CustomChart";

import {
  FieldContainer,
  CustomSelect,
  Option,
} from "../../components/CustomFields";

import {
  individualColumns,
  collectiveColumns,
  chartOption,
  csvIndividualHeaders,
  csvCollectiveHeaders,
} from "./constants";

const Report = () => {
  const { schoolName } = useAuth();
  const [individualValidForm, setIndividualValidForm] = useState(false);
  const [collectiveValidForm, setCollectiveValidForm] = useState(false);
  const [currentTap, setTap] = useState("individual");
  const [chartType, setChartType] = useState("totalCowMilkScore");
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState(form.getFieldsValue(true));

  const dispatch = useDispatch();
  const {
    individualReport,
    individualRawReport,
    individualStatistic = {},
    collectiveReport,
    collectiveRawReport,
    collectiveStatistic = {},
    studentIdOptions = [],
    matchList,
  } = useSelector((s) => s.report);

  const { currentWeek: weeks } = useSelector((s) => s.auth.informInfo);

  useEffect(() => {
    dispatch(onGetSchoolInfo());
    dispatch(onGetMatchList());
  }, []);

  const validate = (formValues) => {
    if (currentTap === "individual") {
      if (formValues.studentId) {
        dispatch(onGetIndividualReport(formValues));
        setIndividualValidForm(true);
        return;
      }
      setIndividualValidForm(false);
    } else if (currentTap === "collective") {
      if (formValues.isCumulative === false) delete formValues.isCumulative;
      if (formValues.week) {
        if (formValues.scope === "school") {
          dispatch(onGetCollectiveReport(formValues));
          setCollectiveValidForm(true);
          return;
        } else if (formValues.scope === "level" && formValues.level) {
          dispatch(onGetCollectiveReport(formValues));
          setCollectiveValidForm(true);
          return;
        } else if (
          formValues.scope === "room" &&
          formValues.level &&
          formValues.room
        ) {
          dispatch(onGetCollectiveReport(formValues));
          setCollectiveValidForm(true);
          return;
        }
      }
      setCollectiveValidForm(false);
    }
  };

  const getTableDetail = () => {
    const detail = [];

    const match = matchList.find((m) => m.id === formValues.semister);
    let matchName = "";
    if (match) matchName = match.name;
    if (currentTap === "individual") {
      detail.push(["มุมมอง", "ระดับบุคคล", "การแข่งขัน", matchName]);
      const student = studentIdOptions.find(
        (s) => s.value === formValues.studentId
      );
      detail.push([
        "ชื่อโรงเรียน",
        schoolName,
        "ชั้น",
        formValues.level,
        "ห้อง",
        formValues.room,
        "เลขที่",
        student ? student.label : "-",
        "ผลถึงสัปดาห์ที่",
        weeks > 16 ? 16 : weeks,
      ]);
    } else {
      const collectiveDetail = [];
      if (formValues.scope === "school") {
        detail.push(["มุมมอง", "ระดับโรงเรียน", "การแข่งขัน", matchName]);
        collectiveDetail.push("ชื่อโรงเรียน", schoolName);
      } else if (formValues.scope === "level") {
        detail.push(["มุมมอง", "ระดับชั้นเรียน", "การแข่งขัน", matchName]);
        collectiveDetail.push(
          "ชื่อโรงเรียน",
          schoolName,
          "ชั้น",
          formValues.level
        );
      } else if (formValues.scope === "room") {
        detail.push(["มุมมอง", "ระดับห้องเรียน", "การแข่งขัน", matchName]);
        collectiveDetail.push(
          "ชื่อโรงเรียน",
          schoolName,
          "ชั้น",
          formValues.level,
          "ห้อง",
          formValues.room
        );
      }

      detail.push([
        ...collectiveDetail,
        formValues.isCumulative ? "ถึงสัปดาห์ที่" : "เฉพาะสัปดาห์ที่",
        formValues.week,
      ]);
    }

    return detail;
  };

  const getChartTitle = (chartView) => {
    let type = "ข้อมูลคะแนน";
    const match = matchList.find((m) => m.id === formValues.semister);
    let matchName = "";
    if (match) matchName = match.name;

    switch (chartView) {
      case "totalCowMilkScore":
        type = `${type} ดื่มดี นมวัว`;
        break;
      case "totalVegetableScore":
        type = `${type} สุขชัวร์ เพิ่มผัก`;
        break;
      case "totalExerciseScore":
        type = `${type} รัก ออกกำลัง`;
        break;
      case "totalSweetDrinkScore":
        type = `${type} หยุดยั้ง น้ำหวาน`;
        break;
      case "all":
        type = `${type} รวมทั้ง 4 ด้าน`;
        break;

      default:
        type = `${type} -`;
        break;
    }

    let studentInfo = "";
    if (currentTap === "individual") {
      const student = studentIdOptions.find(
        (s) => s.value === formValues.studentId
      );
      studentInfo = `ของสามเณรเลขที่ ${student ? student.label : "-"}`;
      studentInfo = `${studentInfo} ชั้น ม.${formValues.level} ห้อง ${formValues.room} โรงเรียน ${schoolName}`;
    } else {
      type = `${type} ${
        formValues.isCumulative ? "ถึงสัปดาห์ที่" : "เฉพาะสัปดาห์ที่"
      } ${formValues.week}`;
      if (formValues.scope === "school") {
        studentInfo = `ของสามเณรโรงเรียน ${schoolName}`;
      } else if (formValues.scope === "level") {
        studentInfo = `ของสามเณรชั้น ม.${formValues.level} โรงเรียน ${schoolName}`;
      } else if (formValues.scope === "room") {
        studentInfo = `ของสามเณรชั้น ม.${formValues.level} ห้อง ${formValues.room}  โรงเรียน ${schoolName}`;
      }
    }
    // `${type} ${matchName}`
    // newline each element
    return [type, studentInfo, matchName];
  };

  useEffect(() => {
    form.setFieldsValue({
      ...formValues,
      isCumulative: undefined,
      level: undefined,
      room: undefined,
      scope: undefined,
      studentId: undefined,
      week: undefined,
    });
  }, [currentTap]);

  return (
    <Container>
      <Background>
        {matchList !== undefined && (
          <Form
            form={form}
            name="report"
            autoComplete="off"
            initialValues={{
              mode: "individual",
              week: weeks <= 16 ? weeks : 16,
              semister: (matchList[0] || {}).id,
            }}
            onValuesChange={(value, values) => {
              if (values.room === undefined || values.level === undefined) {
                setFormValues({
                  ...formValues,
                  ...values,
                  studentId: undefined,
                });
                validate({
                  ...formValues,
                  ...values,
                  studentId: undefined,
                });
              } else {
                setFormValues({ ...formValues, ...value });
                validate({
                  ...formValues,
                  ...values,
                });
              }
            }}
          >
            <ReportForm
              form={form}
              currentTap={currentTap}
              setTap={setTap}
              DownloadBtn={() => (
                <DownloadBtnContainer>
                  {individualReport &&
                    currentTap === "individual" &&
                    individualValidForm &&
                    formValues.studentId && (
                      <DownloadButton
                        dataTable={{
                          dataSource: individualReport,
                          ...individualStatistic,
                        }}
                        chartId={`individual-chart`}
                        csvHeaders={csvIndividualHeaders}
                        details={getTableDetail()}
                      />
                    )}
                  {collectiveReport &&
                    currentTap === "collective" &&
                    collectiveValidForm && (
                      <DownloadButton
                        dataTable={{
                          dataSource: collectiveReport,
                          ...collectiveStatistic,
                        }}
                        chartId={`collective-chart`}
                        csvHeaders={csvCollectiveHeaders}
                        details={getTableDetail()}
                      />
                    )}
                </DownloadBtnContainer>
              )}
            />
            {individualReport &&
              currentTap === "individual" &&
              individualValidForm &&
              formValues.studentId && (
                <ResultTable
                  columns={individualColumns}
                  dataSource={individualReport}
                  mean={individualStatistic.mean || {}}
                  sd={individualStatistic.sd || {}}
                  median={individualStatistic.median || {}}
                />
              )}
            {collectiveReport &&
              currentTap === "collective" &&
              collectiveValidForm && (
                <ResultTable
                  columns={collectiveColumns}
                  dataSource={collectiveReport}
                  mean={collectiveStatistic.mean || {}}
                  sd={collectiveStatistic.sd || {}}
                  median={collectiveStatistic.median || {}}
                />
              )}
            {((individualRawReport &&
              currentTap === "individual" &&
              individualValidForm &&
              formValues.studentId) ||
              (collectiveValidForm &&
                collectiveRawReport &&
                currentTap === "collective")) && (
              <FormContainer>
                <FieldContainer
                  name="chartType"
                  label="ดูในมุมมองกราฟตามหมวด"
                  marginBottom={0}
                >
                  <CustomSelect
                    onChange={setChartType}
                    defaultValue={"totalCowMilkScore"}
                    placeholder="โปรดระบุ"
                    allowClear
                    width="440px"
                  >
                    <Option value={"totalCowMilkScore"}>ดื่มดี นมวัว</Option>
                    <Option value={"totalVegetableScore"}>
                      สุขชัวร์ เพิ่มผัก
                    </Option>
                    <Option value={"totalExerciseScore"}>
                      รัก ออกกำลังกาย
                    </Option>
                    <Option value={"totalSweetDrinkScore"}>
                      หยุดยั้ง น้ำหวาน
                    </Option>
                    <Option value={"all"}>คะแนนรวม</Option>
                  </CustomSelect>
                </FieldContainer>
              </FormContainer>
            )}
            {individualRawReport &&
              currentTap === "individual" &&
              individualValidForm &&
              formValues.studentId && (
                <CustomChart
                  chartData={individualRawReport.map((data) => ({
                    name: data.name || "-",
                    data: data[chartType],
                  }))}
                  chartOption={{
                    ...chartOption,
                    chart: { ...chartOption.chart, id: `individual-chart` },
                    yaxis: {
                      ...chartOption.yaxis,
                      max: chartType === "all" ? 72 : 18,
                    },
                    title: {
                      ...chartOption.title,
                      text: getChartTitle(chartType),
                    },
                  }}
                  dataTable={{
                    dataSource: individualReport,
                    ...individualStatistic,
                  }}
                  csvHeaders={csvIndividualHeaders}
                  details={getTableDetail()}
                />
              )}
            {collectiveRawReport &&
              currentTap === "collective" &&
              collectiveValidForm && (
                <CustomChart
                  chartData={collectiveRawReport.map((data) => ({
                    name: data.name,
                    data: data[chartType],
                  }))}
                  chartOption={{
                    ...chartOption,
                    chart: {
                      ...chartOption.chart,
                      id: `collective-chart`,
                    },
                    yaxis: {
                      ...chartOption.yaxis,
                      max: chartType === "all" ? 72 : 18,
                    },
                    title: {
                      ...chartOption.title,
                      text: getChartTitle(chartType),
                    },
                  }}
                  dataTable={{
                    dataSource: collectiveReport,
                    ...collectiveStatistic,
                  }}
                  csvHeaders={csvCollectiveHeaders}
                  details={getTableDetail()}
                />
              )}
          </Form>
        )}
      </Background>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;

  display: flex;
  justify-content: center;
  align-items: center;

  .ant-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const Background = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1144px;

  background-color: white;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;

  padding-bottom: 80px;

  ${responsive.tablet(css`
    max-width: unset;
    padding-bottom: 50px;
  `)}

  ${responsive.mobile(css`
    padding-bottom: 40px;
  `)}
`;

const FormContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 440px;
  width: calc(100vh - 30px);

  margin-top: 48px;

  ${responsive.mobile(css`
    max-width: 343px;
  `)}
`;

const DownloadBtnContainer = styled.div`
  position: absolute;
  top: -12px;
  right: 0;
`;

export default Report;
